import type {
  RecentRevenueActivityResponseDTO,
  RecentRevenueActivityItemDTO,
} from "../api/clientOverviewApi";
import type {
  RecentRevenueActivityEntity,
  RecentRevenueActivityItemEntity,
} from "../../domain/entities/RecentRevenueActivityEntity";

function formatDateShort(iso: string): string {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return iso;
    return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
  } catch {
    return iso;
  }
}

function itemDtoToEntity(dto: RecentRevenueActivityItemDTO): RecentRevenueActivityItemEntity {
  return {
    id: dto.id,
    date: formatDateShort(dto.date),
    invoiceNo: dto.invoiceNo ?? "—",
    customer: dto.customer ?? "—",
    amount: dto.amount ?? "—",
    status: dto.status,
    dueDate: formatDateShort(dto.dueDate),
  };
}

export function recentRevenueActivityDtoToEntity(
  dto: RecentRevenueActivityResponseDTO
): RecentRevenueActivityEntity {
  return {
    items: (dto.items ?? []).map(itemDtoToEntity),
    pagination: {
      total: dto.pagination?.total ?? 0,
      limit: dto.pagination?.limit ?? 10,
      page: dto.pagination?.page ?? 1,
      totalPages: dto.pagination?.total_pages ?? 0,
      hasMore: dto.pagination?.has_more ?? false,
    },
  };
}
